import React, { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu, Power, X } from "lucide-react";
import { Toaster } from "sonner";
import { useAuth } from "@/auth";

const NAV = [
  { to: "/admin/result", label: "Manage Result" },
  { to: "/admin/common-number", label: "Common Number" },
  { to: "/admin/previous-results", label: "Previous Results" },
  { to: "/admin/change-password", label: "Change Password" },
];

const TITLES = {
  "/admin/common-number": "Common Number",
  "/admin/result": "Result",
  "/admin/previous-results": "Previous Results",
  "/admin/change-password": "Change Password",
};

export default function AdminLayout({ children }) {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const title = TITLES[loc.pathname] || "Admin";

  const onLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  return (
    <div className="ap-shell" data-testid="admin-shell">
      <header className="ap-topbar" data-testid="admin-topbar">
        <button
          className="ap-menu-btn"
          data-testid="admin-menu-toggle"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu />
        </button>
        <h1 className="ap-title" data-testid="admin-page-title">{title}</h1>
        <button
          className="ap-logout"
          data-testid="admin-logout-button"
          onClick={onLogout}
        >
          <Power size={18} /> Log Out
        </button>
      </header>

      {open && (
        <div className="ap-drawer-backdrop" data-testid="admin-drawer" onClick={() => setOpen(false)}>
          <aside className="ap-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="ap-drawer-head">
              <strong>Menu</strong>
              <button
                className="ap-drawer-close"
                data-testid="admin-drawer-close"
                onClick={() => setOpen(false)}
                aria-label="Close menu"
              >
                <X />
              </button>
            </div>
            <nav className="ap-drawer-nav">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  data-testid={`admin-nav-${n.to.split("/").pop()}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `ap-nav-link${isActive ? " active" : ""}`}
                >
                  {n.label}
                </NavLink>
              ))}
              <Link to="/" className="ap-nav-link ap-nav-view" data-testid="admin-nav-view-site" onClick={() => setOpen(false)}>
                View Website
              </Link>
            </nav>
          </aside>
        </div>
      )}

      <main className="ap-main">{children}</main>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
